import { Route} from 'react-router-dom'
import Modal from 'react-modal'
import {
  APPLICATION_STATUS_OPENED,
  APPLICATION_STATUS_PENDING,
  APPLICATION_STATUS_PENDING_AGENCY,
  APPLICATION_STATUS_PENDING_PAYMENT,
  APPLICATION_STATUS_UNDER_REVIEW,
  APPLICATION_STATUS_UNREAD,
  ERROR_CODE,
} from './constants'
import { useDispatch, useSelector } from 'react-redux';
import { nsLoginSelect } from '../redux/selector/nsLoginSelector'
import userAuthSelect  from '../redux/selector/userAuthSelector'
import { fetchLicenceTypeDetails, saveNextUrl } from '../redux/slice/primaryAgencyApplicationSlice'
import { getAccountInfo } from '../redux/slice/userAuthSlice'
import { useEffect, useState } from 'react'
import { fetchApplicationWithIdAndSetStore, fetchMyApplicationData } from '../redux/slice/collectionApplicationSlice'
// import { fetchRjscFromNumberAndSetDetails } from '../redux/slice/rjscSearchSlice'
import { Button } from '../components/RegularComponents';
import { startNSLogin } from '../redux/slice/nsLoginSlice';
import { isUserBusinessAdmin } from './utils';
import { fetchQueue } from '../redux/slice/bltHomeSlice'
import { isAgencyTypeApplication, isRenewalTypeApplication } from '../redux/slice/applicationsUtils';
import { fetchArchiveApplicationsForOriginalId } from '../redux/slice/archiveApplicationsSlice';

const PreloadWrapper = (props) => {
    const {children} = props
    const dispatch = useDispatch()
    const {nsLogin} = useSelector(nsLoginSelect)
    const {userAuth} = useSelector(userAuthSelect)
    const [sanityInProgress, setSanityInProgress] = useState(false)
    const [showLoginExpiredModal, setShowLoginExpiredModal] = useState(nsLogin.loginExpired)

    useEffect(() => {
      setShowLoginExpiredModal(nsLogin.loginExpired)
    }, [
      setShowLoginExpiredModal, 
      nsLogin.loginExpired
    ])

    if(!sanityInProgress && !userAuth.userData) {
      setSanityInProgress(true)
      dispatch(getAccountInfo())
        .then(accountResp => { 
          if(isUserBusinessAdmin(accountResp)) { 
             dispatch(fetchQueue()).then(data => {
                setSanityInProgress(false)
             })
          } else { 
            dispatch(fetchMyApplicationData())
              .then((myApplicationResp) => { 
                  setSanityInProgress(false)

                  if(myApplicationResp && myApplicationResp.id > 0) { 
                    let appData = myApplicationResp.businessLicenceData

                    if(!appData) {
                      dispatch(fetchApplicationWithIdAndSetStore(myApplicationResp.id))
                        .then(data => {

                            appData = data.businessLicenceData

                            dispatch(fetchLicenceTypeDetails(data.licencingSubType))
                              .then(licenceData => {
                                  if(isAgencyTypeApplication(data) && 
                                          isRenewalTypeApplication(data) && 
                                          (data.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
                                              || data.applicationStatus === APPLICATION_STATUS_PENDING_AGENCY
                                              || data.applicationStatus === APPLICATION_STATUS_UNDER_REVIEW
                                              || data.applicationStatus === APPLICATION_STATUS_UNREAD
                                              || data.applicationStatus === APPLICATION_STATUS_OPENED
                                              || data.applicationStatus === APPLICATION_STATUS_PENDING)) {
                                      //console.log("fetching archive data..")
                                      
                                      dispatch(fetchArchiveApplicationsForOriginalId(myApplicationResp.id))
                                          .then(archiveData => {
                                              //console.log("archive data fetched...")
                                          })
                                          .catch(error => {
                                              console.error(error)
                                          })
                                  }
                              })
                              .catch(error => {
                                  console.error("licence type data fetch error", error)
                              })
                              
                            // if(appData && appData.registryNumber) {
                            //     dispatch(fetchRjscFromNumberAndSetDetails(appData.registryNumber))
                            // }
                        })
                    }
                    // else if(appData && appData.registryNumber) {
                    //     dispatch(fetchRjscFromNumberAndSetDetails(appData.registryNumber))
                    // }
                  }
              })
          }
      })
      .catch(err => {
        if(err === ERROR_CODE.UNAUTHORISED_ACCESS) { 
          // need to login again
          setShowLoginExpiredModal(true)
        }
      })
    }
  
    return (
      <>
      {!(userAuth.userData) 
        ? <div className={"container"}>
            <div className="row topMarginLarge">
                <div className="col-12 centered">
                    <p className="statusText">
                        fetching data...
                    </p>
                </div>
            </div>
        </div>
          : children}
      <Modal
        appElement={document.getElementById('root')}
        isOpen={showLoginExpiredModal}
        contentLabel="loginExpiredModal"
        onRequestClose={() => { setShowLoginExpiredModal(false) }}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        className="loginExpiredModal"
        closeTimeoutMS={150}>
          <div 
            className="" 
            style={{
              display: "flex", 
              flexDirection:"row",
              alignItems: "center"
            }}>
            <div className="col-2 has-error">
              <i className="fa fa-exclamation-circle fa-2x" />
            </div>
            <div className="col-10 topMarginNormal">
              <div className="row bottomMarginMedium">
                <div className="col-11">
                    Your Login has expired. Login again to continue.
                </div>
              </div>
              <div className="row">
                  <div className="col-11 rightAlign">
                    <Button 
                      text="Login"
                      id="ns-login"
                      buttonType="regular_primary"
                      onClick={() => {
                        setShowLoginExpiredModal(false)
                        dispatch(saveNextUrl(`${children.props.location.pathname}${children.props.location.search}`))
                        dispatch(startNSLogin())
                      }}
                    />
                  </div>
                </div>
            </div>
          </div>
      </Modal>
    </>)
}
  
export function PreloadedRoute({ component: Component, ...rest }) { 
    return (
      <Route
        {...rest}
        render={routeProps => (
          <PreloadWrapper>
            <Component {...routeProps} />
          </PreloadWrapper>
        )}
      />
    );
}